import { useQuery } from '@tanstack/react-query'
import { toast } from 'sonner'
import { queryKeys } from '@/shared/constants/query-keys'
import { getErrorMessage } from '@/shared/utils/handle-api-error'
import type { IAdvisor, IUser } from '../models/user'
import {
  type ISearchUsersAndClientsResult,
  type IUserLookup,
  usersService
} from '../services/user.service'

export type { IUserLookup }

export const useUsersLookupQuery = (dependence = true) => {
  return useQuery<IUserLookup[]>({
    queryKey: queryKeys.users.lookup(),
    queryFn: async () => {
      try {
        return await usersService.getLookup()
      } catch (error) {
        console.error(error)
        toast.error(getErrorMessage(error))
        return []
      }
    },
    refetchOnWindowFocus: false,
    enabled: dependence
  })
}

export const useUsersLookupAllQuery = (dependence = true) => {
  return useQuery<IUserLookup[]>({
    queryKey: queryKeys.users.lookupAll(),
    queryFn: async () => {
      try {
        return await usersService.getLookupAll()
      } catch (error) {
        console.error(error)
        toast.error(getErrorMessage(error))
        return []
      }
    },
    refetchOnWindowFocus: false,
    enabled: dependence
  })
}

export const useMyAccountQuery = (dependence = true) => {
  return useQuery<IUser | null>({
    queryKey: queryKeys.users.me(),
    queryFn: async () => {
      try {
        return await usersService.getMe()
      } catch (e) {
        console.error('MY ACCOUNT => ', e)
        return null
      }
    },
    refetchOnWindowFocus: false,
    enabled: dependence
  })
}

export const useAdvisorsQuery = (dependence = true) => {
  return useQuery<IAdvisor[]>({
    queryKey: queryKeys.users.advisors(),
    queryFn: async () => {
      try {
        return await usersService.getAdvisors()
      } catch (error) {
        console.error(error)
        toast.error(getErrorMessage(error))
        return []
      }
    },
    refetchOnWindowFocus: false,
    enabled: dependence
  })
}

export const useSearchUsersAndClientsQuery = (query: string, enabled = true) => {
  return useQuery<ISearchUsersAndClientsResult[]>({
    queryKey: queryKeys.users.searchUsersClients(query),
    queryFn: async () => {
      try {
        if (!query || query.length < 2) return []
        return await usersService.searchUsersAndClients(query)
      } catch (error) {
        console.error(error)
        return []
      }
    },
    refetchOnWindowFocus: false,
    enabled: enabled && query.length >= 2
  })
}
